import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { OffsetTopThree, OffsetTopTwo } from "../../component/body/body";
import { color, themeType, typo } from '../../styles/style';
import ButtonAtom from '../atoms/ButtonAtom';
import ImgAtom from '../atoms/ImgAtom';
import TextAtom from '../atoms/TextAtom';

const ContentBoxOuter = styled.div`
display: flex;
align-items: center;
justify-content: flex-end;
height: ${(props) => props.height || "100%"};
width: ${(props) => props.width || "100%"};
padding:${(props) => props.padding || "0"};
    text-align: center;
margin:${(props) => props.margin || "0"};
margin-bottom: 94px;
background:${(props) => props.background || "0"};
  ${({ theme }) => theme.media.tablet`
  background: #f9f9f9;
    `}
  ${({ theme }) => theme.media.mobile`
  width:100%;
  max-width: 100%;
  justify-content: space-evenly;
  margin: 0;
  background: #f9f9f9;
    `}
`
const ContentBox = styled.div`
  display: flex;
  align-items: center;
  height: 646px;
  justify-content: ${(props) => props.justifyContent || "center"};
  width: ${(props) => props.width || "90%"};
  padding: ${(props) => props.padding || "0"};
  margin: ${(props) => props.margin || "0"};
  flex-direction: ${(props) => props.flexDirection || "row"};
  background: ${(props) => props.background || "transparent"};
  border-radius: ${(props) => props.borderRadius || "row"};
  ${({ theme }) => theme.media.tablet`
    `}
  ${({ theme }) => theme.media.mobile`
  width:100%;
  max-width: 100%;
  justify-content: space-evenly;
    `}
`;
const ContentleftBox = styled.div`
  display: flex;
  max-width: 438px;
  width: 40%;
  height: 80%;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-left: 10%;
  ${({ theme }) => theme.media.tablet`
  width:100%;
  max-width: 100%;
  justify-content: space-evenly;
  margin: 0;
    `}
  ${({ theme }) => theme.media.mobile`
  width:100%;
  max-width: 100%;
  justify-content: space-evenly;
  margin: 0;
    `}
`;
const ContentrightBox = styled.div`
  display: flex;
  width: 45%;
  height: 100%;
  flex-wrap: wrap;
  ${({ theme }) => theme.media.tablet`
  display: none;
    `}
  ${({ theme }) => theme.media.mobile`
  display: none;
    `}
`;

const ContentDiv = styled.div`
  width: auto;
  height: auto;
  color: #374553;
  font-size: 20px;
  font-weight: 400;
  line-height: 35px;
`;

const Bold = styled.b`
font-weight: 700;
`



class FirstContentMolecule extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            
        }
    }

    render() {
        return (
          <ContentBoxOuter id={this.props.id}>
            <ContentBox
              flexDirection="row"
              margin="120px 0 0 0"
              background="#f9f9f9"
              borderRadius="35px 0 0 35px"
              height="646px"
              justifyContent="flex-start"
            >
              <ContentBox justifyContent="space-between" width="88.88%">
                <ContentleftBox>
                  <TextAtom
                    text="Rising High and Strong, LAB254"
                    typo={typo.header.h1}
                    fontSizeM="font-size : 35px"
                    color={color(themeType.dark).text.primary}
                  />
                  <ContentDiv>
                    we make <Bold>valuable apps</Bold> with google mobile
                    application framework <Bold>'FLUTTER'</Bold>
                  </ContentDiv>
                  <ButtonAtom
                    text="Contact"
                    width="201px"
                    height="67px"
                    background="#000000"
                    border="3px solid #0c0c0c"
                    color={color(themeType.light).text.primary}
                    onClick = {OffsetTopThree}
                  />
                  <ButtonAtom
                    text="Project"
                    width="201px"
                    height="67px"
                    border="3px solid #0c0c0c"
                    color={color(themeType.dark).text.primary}
                    onClick = {OffsetTopTwo}
                  />
                </ContentleftBox>
                <ContentrightBox>
                  <ImgAtom
                    src="../images/image1.png"
                    padding="0"
                    borderRadius="20px"
                    minWidth="396px"
                  />
                </ContentrightBox>
              </ContentBox>
            </ContentBox>
          </ContentBoxOuter>
        );
    }
}

export default FirstContentMolecule